// Computes the inclusive 1-based range and totals shown by a "Page X of Y · Showing A–B of N"
// pagination label. Centralized so Active and Community render the label identically.
export function computePaginationRange({ currentPage, pageSize, totalItems }) {
  const safeTotal = Math.max(0, Math.floor(Number(totalItems) || 0));
  const safePageSize = Math.max(1, Math.floor(Number(pageSize) || 1));
  const totalPages = Math.max(1, Math.ceil(safeTotal / safePageSize));
  const safePage = Math.min(
    Math.max(1, Math.floor(Number(currentPage) || 1)),
    totalPages
  );

  if (safeTotal === 0) {
    return {
      safePage: 1,
      totalPages: 1,
      rangeStart: 0,
      rangeEnd: 0,
      totalItems: 0,
    };
  }

  const rangeStart = (safePage - 1) * safePageSize + 1;
  const rangeEnd = Math.min(safePage * safePageSize, safeTotal);

  return { safePage, totalPages, rangeStart, rangeEnd, totalItems: safeTotal };
}
